export default __webpack_public_path__ + "static/media/cancel.adb3c95a.png";